import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import {
  AlertActionObject,
  AlertActionType,
  AlertListObject,
  AlertMessages,
  AlertObject,
  AlertOption,
  AlertType
} from "./alert.datamodel";

/**
 * Component representing an alert popup.
 */
@Component({
    selector: "ama-ng-alert-message",
    templateUrl: "./alert.component.html",
    standalone: false
})
export class AlertMessageComponent {
  title!: string;
  messages: { [type: string]: AlertMessages } = {};
  question!: string;
  options: AlertOption[] = [];
  optionsForm?: UntypedFormGroup;
  actions: AlertActionObject[] = [];

  ALERT_ACTION_TYPE = AlertActionType;

  constructor(public activeModal: NgbActiveModal, readonly alertObjects: AlertListObject) {
    this.showAlertMessageWithObjects();
  }

  /**
   * Show alert messages via Alert objects.
   */
  showAlertMessageWithObjects() {
    const title = this.alertObjects.title || "Oops!";
    const question =
      this.alertObjects.question === undefined || this.alertObjects.question === null
        ? "If the problem still occurs, please contact your helpdesk."
        : this.alertObjects.question;

    if (this.alertObjects.alerts != null && this.alertObjects.alerts.length > 0) {
      this.initAlertMessage(
        title,
        this.alertObjects.alerts,
        question,
        this.alertObjects.actions,
        this.alertObjects.options
      );
    }
  }

  /**
   * Button action clicked.
   * @param callback
   */
  btnActionClickHandler(callback: CallableFunction) {
    if (callback !== undefined) {
      if (this.optionsForm) {
        callback(this.optionsForm.get("selectedOption")?.value);
      } else {
        callback();
      }
    }
    this.activeModal.close();
  }

  /**
   * Set the button action style according to the type of action.
   * @param type
   */
  setAlertBtnActionStyle(type: AlertActionType): string {
    switch (type) {
      case this.ALERT_ACTION_TYPE.PRIMARY:
        return "btn-primary";
      case this.ALERT_ACTION_TYPE.SECONDARY:
        return "btn-outline-primary me-5";
      default:
        return "btn-primary";
    }
  }

  /**
   * Init alert message.
   * @param title Title of the message
   * @param rawAlerts Alerts to be parsed and aggregated according to their types
   * @param question Question
   * @param actions List of action
   * @param options
   */
  private initAlertMessage(
    title: string,
    rawAlerts: AlertObject[],
    question: string,
    actions: Array<AlertActionObject>,
    options: AlertOption[] | undefined
  ) {
    this.title = title;
    this.question = question;
    this.actions = actions;

    if (options) {
      this.options = options;
    }
    if (options && options.length) {
      this.optionsForm = new UntypedFormGroup({
        selectedOption: new UntypedFormControl(options[0])
      });
    } else {
      this.optionsForm = undefined;
    }

    this.messages = {
      E: { messages: [], type: AlertType.ERROR },
      W: { messages: [], type: AlertType.WARNING },
      I: { messages: [], type: AlertType.INFO }
    };
    rawAlerts.forEach(rawAlert => {
      this.messages[rawAlert.type].messages.push(rawAlert.message!);
    });
  }
}
